<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="edit-title m-0 p-0">Configurare Sloturi Programare</h1>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="text-center mb-4">
        <h3 class="mb-2">{{ data.nume_specialist }}</h3>
        <p class="mb-0"><strong>Specializare:</strong> {{ data.denumire_specializare }}</p>
        <p class="mb-0"><strong>Tip Problemă:</strong> {{ data.denumire_tip_problema }}</p>
        <p class="mb-0"><strong>Locație:</strong> {{ data.denumire_locatie }}</p>
        <p class="mb-0" *ngIf="durataProgramare"><strong>Durată programare:</strong> {{ durataProgramare }} minute</p>
    </div>

    <div class="program-content">
        <div class="d-flex flex-wrap gap-2 mb-3">
            <button *ngFor="let day of daysOfWeek" type="button" class="action-button" (click)="selectDay(day.id_day)"
                [class.active-day]="selectedDayID === day.id_day">
                <span>{{day.day}}</span>
            </button>
        </div>
        <p>Intervale disponibile:</p>
        <div class="d-flex justify-content-between flex-wrap gap-2">
            <div class="row">
                <div class="col">
                    <mat-form-field class="" appearance="fill">
                        <mat-label>Ora</mat-label>
                        <mat-select [(ngModel)]="timeCursor.hour">
                            <mat-option *ngFor="let hour of possibleHours" [value]="hour">
                                {{ hour }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="" appearance="fill">
                        <mat-label>Minutul</mat-label>
                        <mat-select [(ngModel)]="timeCursor.minute">
                            <mat-option *ngFor="let minute of possibleMinutes" [value]="minute">
                                {{ minute }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <button type="button" class="my-2 action-button" (click)="addTime()">
                <span>Adaugă</span>
            </button>
        </div>
        <div class="d-flex justify-content-between flex-wrap gap-2">
            <mat-chip-listbox aria-label="Time selection">
                <ng-container *ngFor="let time of timeSlots; index as timeIndex">
                    <mat-chip *ngIf="time.day === selectedDayID && !time.deleted">
                        {{ time.hour }}:{{ time.minute }}
                        <button type="button" matChipRemove aria-label="Remove time" (click)="removeTime(timeIndex)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                </ng-container>
            </mat-chip-listbox>
        </div>
    </div>

    <!-- Butoane acțiuni -->
    <div class="row mt-4">
        <div class="col d-flex justify-content-between">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="button" mat-flat-button color="primary"
                [disabled]="isLoading || !durataProgramare" (click)="saveSloturi()">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <!-- Spinner -->
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>